import React, { useEffect, useState } from "react";
import SEO from "../Common/SEO";

const Blogs = () => {
  const [playingVideoIndex, setPlayingVideoIndex] = useState(null);
  const [playingIndex, setPlayingIndex] = useState(null);
  const videos = [
    {
      url: "https://youtu.be/K6Ad03ESicM?si=yTqJIAP8bfvh7vQw",
      thumbnail: "https://img.youtube.com/vi/K6Ad03ESicM/0.jpg",
      title: "CART STUDIO INTERVIEW",
    },
    {
      url: "https://youtu.be/GyuNimd2jIU?si=wTIMuztModTDjCxO",
      thumbnail: "https://img.youtube.com/vi/GyuNimd2jIU/0.jpg",
      title: "ICE-CREAM PARLOUR",
    },
    {
      url: "https://youtu.be/WVQyqPIrIak?si=4XHpZY4osKE0u5s7",
      thumbnail: "https://img.youtube.com/vi/WVQyqPIrIak/0.jpg",
      title: "BIG PRIZE",
    },
  ];

  const facebookVideos = [
    {
      url: "https://www.facebook.com/facebook/videos/10153231379946729/",
      thumbnail: "https://yourcdn.com/thumbs/facebook-video-1.jpg",
      title: "Facebook Video 1",
      isEmbeddable: true,
    },
    // {
    //   url: "https://www.facebook.com/natgeo/videos/1234567890123456/",
    //   thumbnail: "https://yourcdn.com/thumbs/facebook-video-2.jpg",
    //   title: "Facebook Video 2",
    //   isEmbeddable: true,
    // },
    // Add more as needed
  ];

  function extractEmbedId(url) {
    const regex = /(?:youtu\.be\/|v=)([a-zA-Z0-9_-]{11})/;
    const match = url.match(regex);
    return match ? match[1] : null;
  }

  const videosWithEmbedId = videos.map((video) => ({
    ...video,
    embedId: extractEmbedId(video.url),
  }));

  useEffect(() => {
    if (playingIndex !== null) {
      // Load Facebook SDK
      if (!window.FB) {
        const script = document.createElement("script");
        script.src =
          "https://connect.facebook.net/en_US/sdk.js#xfbml=1&version=v19.0";
        script.async = true;
        script.defer = true;
        script.crossOrigin = "anonymous";
        script.onload = () => {
          if (window.FB) window.FB.XFBML.parse();
        };
        document.body.appendChild(script);
      } else {
        window.FB.XFBML.parse();
      }
    }
  }, [playingIndex]);
  return (
    <>
      <SEO 
        title="Blogs & Videos | Cart Studio"
        description="Watch our latest interviews and product demonstrations. Stay updated with Cart Studio's innovative mobility solutions and business success stories."
      />
      <div className="section mt-10">
        <div className=" section-title p-0  " data-aos="fade-up">
          <span className="subtitle">Blogs & Videos</span>
          <h1>OUR LATEST UPDATES</h1>
        </div>
        <div className="container mt-2">
          {/* ... existing content ... */}
          <p>Youtube Video's</p>
          <div className="flex flex-col md:flex-row gap-6 flex-wrap">
            {videosWithEmbedId.map((video, index) => (
              <div
                key={index}
                className="relative border-2 border-gray-200 rounded-lg overflow-hidden shadow-md w-full md:w-80 flex flex-col gap-2"
                style={{ minHeight: "300px" }} // Fixed min-height for consistent card height
              >
                {/* Video preview area */}
                <div className="w-full h-48 md:h-44 p-2">
                  {playingVideoIndex === index ? (
                    <iframe
                      className="w-full h-full"
                      src={`https://www.youtube.com/embed/${video.embedId}?autoplay=1`}
                      title={video.title}
                      frameBorder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                      allowFullScreen
                    />
                  ) : (
                    <div className="relative h-full">
                      <img
                        src={video.thumbnail}
                        alt={video.title}
                        className="w-full h-full object-cover"
                      />
                      <button
                        onClick={() => setPlayingVideoIndex(index)}
                        className="absolute inset-0 flex items-center justify-center hover:bg-black/40 transition"
                      >
                        <svg
                          className="w-16 h-16 text-white"
                          fill="currentColor"
                          viewBox="0 0 84 84"
                        >
                          <circle cx="42" cy="42" r="42" fill="rgba(0,0,0,0.6)" />
                          <polygon points="33,26 60,42 33,58" fill="white" />
                        </svg>
                      </button>
                    </div>
                  )}
                </div>

                {/* Title and Watch button area */}
                <div className="p-4 flex flex-col">
                  <p className=" font-semibold mb-4">{video.title}</p>
                  <button
                    onClick={() => window.open(video.url, "_blank")}
                    className="mt-auto px-4 py-2 bg-orange-600 hover:bg-orange-700 text-white rounded text-sm"
                  >
                    Watch on YouTube
                  </button>
                </div>
              </div>
            ))}
          </div>

          <div className="mt-4">
            <p className="mt-2">Facebook Video's</p>
            <div className="flex flex-col md:flex-row gap-6 flex-wrap">
              {facebookVideos.map((video, index) => (
                <div
                  key={index}
                  className="relative  rounded-lg overflow-hidden shadow-md w-full md:w-80 flex flex-col justify-between"
                  // style={{ minHeight: "360px" }}
                >
                  <div className="p-4  flex flex-col">
                    {/* <h2 className="text-lg font-semibold mb-4">{video.title}</h2> */}
                    <button
                      onClick={() => window.open(video.url, "_blank")}
                      className="mt-auto px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded text-sm"
                    >
                      Watch on Facebook
                    </button>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Blogs;
